import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Most of my <b className="purple">professional experience</b> has been gained from hackathons, conferences, and networking within the open source communities. <br/> <br/> Through these opportunities, I have had the chance to <b className="purple">collaborate</b> with a diverse range of individuals and work on <b className="purple">challenging projects</b>  that have helped me <b className="purple">develop</b> my skills and knowledge in programming and <b className="purple">technology.</b><br/>
            
            <br />
            Apart from coding, some other activities that I love to do!
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> Writting Tech Blogs
            </li>
            <li className="about-activity">
              <ImPointRight /> Brainstroming about AI
            </li>
            <li className="about-activity">
              <ImPointRight /> Travelling and exploring new places
            </li>
          </ul>

          <p style={{ color: "rgb(155 126 172)" }}>
            "The journey to become an AI engineer is challenging, but the possibilities for innovation and positive change are limitless!"{" "}
          </p>
          <footer className="blockquote-footer">Zoya Jmd 🎓</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
